(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sg-before-you-order-faq"] && !Shopify.designMode) return;
  try {
    (function () {
    function openItem(item, button, panel) {
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.style.maxHeight = '0px';

      window.requestAnimationFrame(function () {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    }

    function closeItem(item, button, panel) {
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      panel.style.maxHeight = panel.scrollHeight + 'px';

      window.requestAnimationFrame(function () {
        panel.style.maxHeight = '0px';
      });

      var onTransitionEnd = function (event) {
        if (event.propertyName !== 'max-height') return;
        panel.removeEventListener('transitionend', onTransitionEnd);
        if (button.getAttribute('aria-expanded') === 'false') {
          panel.hidden = true;
        }
      };

      panel.addEventListener('transitionend', onTransitionEnd);
    }

    function initBeforeOrderFaq(root) {
      if (!root || root.dataset.sgBeforeOrderFaqReady === 'true') return;
      root.dataset.sgBeforeOrderFaqReady = 'true';

      if (root.hasAttribute('data-custom-coaster-faq') && 'ResizeObserver' in window) {
        var answerResizeObserver = new ResizeObserver(function () {
          root.querySelectorAll('.sg-before-order-faq__item.is-open .sg-before-order-faq__answer').forEach(function (panel) {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          });
        });
        root.querySelectorAll('.sg-before-order-faq__answer-inner').forEach(function (inner) {
          answerResizeObserver.observe(inner);
        });
      }

      root.querySelectorAll('.sg-before-order-faq__question').forEach(function (button) {
        var item = button.closest('.sg-before-order-faq__item');
        var panel = root.querySelector('#' + button.getAttribute('aria-controls'));

        if (!item || !panel) return;

        button.addEventListener('click', function () {
          if (button.getAttribute('aria-expanded') === 'true') {
            closeItem(item, button, panel);
          } else {
            openItem(item, button, panel);
          }
        });
      });
    }

    function initAllBeforeOrderFaqs(scope) {
      (scope || document).querySelectorAll('[data-sg-before-order-faq]').forEach(initBeforeOrderFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllBeforeOrderFaqs(document);
      });
    } else {
      initAllBeforeOrderFaqs(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAllBeforeOrderFaqs(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sg-coaster-colour-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', event => {
    if (!event.target.matches('.sg-coaster-colours input[type="radio"]')) return;
    const picker = event.target.closest('.sg-coaster-picker');
    picker.querySelectorAll('[data-coaster-selected]').forEach(label => { label.textContent = event.target.value; });
    picker.querySelector('.sg-coaster-error').hidden = true;
    picker.querySelector('.sg-coaster-hint').textContent = 'Choose one coaster colour. Selected: ' + event.target.value + '.';
  });
  document.addEventListener('submit', event => {
    if (!(event.target instanceof HTMLFormElement)) return;
    const picker = Array.from(document.querySelectorAll('.sg-coaster-picker[data-form-id]')).find(node => node.dataset.formId === event.target.getAttribute('id'));
    if (!picker || picker.querySelector('input:checked')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    picker.querySelector('details').open = true;
    picker.querySelector('.sg-coaster-error').hidden = false;
    picker.querySelector('input').focus();
  }, true);
  document.addEventListener('click', event => {
    const done = event.target.closest('.sg-coaster-done');
    if (!done) return;
    const card = done.closest('.sg-coaster-colours');
    card.open = false;
    card.querySelector('summary').focus({ preventScroll: true });
  });
  document.addEventListener('keydown', event => {
    const card = event.target.closest('.sg-coaster-colours');
    if (!card || event.key !== 'Escape' || !card.open) return;
    event.preventDefault();
    card.open = false;
    card.querySelector('summary').focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sg-custom-team-bag-tag-personalization"] && !Shopify.designMode) return;
  try {
    (() => {
    const maximumFileSize = 20 * 1024 * 1024;
    const allowedExtensions = ['png', 'jpg', 'jpeg', 'webp', 'heic', 'heif', 'gif'];
    const tierNudgeTimers = new WeakMap();

    function setError(container, input, message) {
      const isRosterInput = input && input.matches('[data-sg-last-name]');
      const error = container.querySelector(isRosterInput ? '[data-sg-roster-error]' : '[data-sg-team-tag-error]');
      container.querySelectorAll('.sg-team-tag-personalization__field').forEach((field) => {
        field.classList.toggle('sg-team-tag-personalization__field--invalid', field.contains(input));
      });
      if (error) {
        error.textContent = message;
        error.hidden = false;
      }
      input.setCustomValidity(message);
      if (isRosterInput) {
        openRoster(container, input);
      } else {
        input.focus({ preventScroll: true });
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        input.reportValidity();
      }
      return false;
    }

    function clearError(container) {
      container.querySelectorAll('.sg-team-tag-personalization__field').forEach((field) => {
        field.classList.remove('sg-team-tag-personalization__field--invalid');
      });
      container.querySelectorAll('input').forEach((input) => input.setCustomValidity(''));
      container.querySelectorAll('[data-sg-team-tag-error], [data-sg-roster-error]').forEach((error) => {
        error.textContent = '';
        error.hidden = true;
      });
    }

    function getQuantityInput(form) {
      return Array.from(document.querySelectorAll('input[name="quantity"]')).find((input) => input.form === form);
    }

    function getQuantity(quantityInput) {
      const quantity = quantityInput ? Number.parseInt(quantityInput.value, 10) : 1;
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function formatTierMessage(template, quantity, price) {
      return template.replace('[quantity]', String(quantity)).replace('[price]', price);
    }

    function getTierMessage(container, quantity) {
      if (quantity >= 50) {
        return {
          message: formatTierMessage(container.dataset.tierBestTemplate, 0, container.getAttribute('data-tier-price-50')),
          tone: 'success',
        };
      }

      if (quantity === 25) {
        return {
          message: formatTierMessage(container.dataset.tierUnlockedTemplate, 0, container.getAttribute('data-tier-price-25')),
          tone: 'success',
        };
      }

      if (quantity === 10) {
        return {
          message: formatTierMessage(container.dataset.tierUnlockedTemplate, 0, container.getAttribute('data-tier-price-10')),
          tone: 'success',
        };
      }

      const nextQuantity = quantity < 10 ? 10 : quantity < 25 ? 25 : 50;
      const nextPrice = quantity < 10
        ? container.getAttribute('data-tier-price-10')
        : quantity < 25
          ? container.getAttribute('data-tier-price-25')
          : container.getAttribute('data-tier-price-50');

      return {
        message: formatTierMessage(container.dataset.tierNudgeTemplate, nextQuantity - quantity, nextPrice),
        tone: 'progress',
      };
    }

    function getClassicHypeTierMessage(container, quantity) {
      const tiers = [
        { quantity: 10, price: container.getAttribute('data-tier-price-10') },
        { quantity: 20, price: container.getAttribute('data-tier-price-20') },
        { quantity: 30, price: container.getAttribute('data-tier-price-30') },
        { quantity: 50, price: container.getAttribute('data-tier-price-50') },
        { quantity: 100, price: container.getAttribute('data-tier-price-100') },
      ];

      if (quantity >= 100) {
        return {
          message: formatTierMessage(container.dataset.tierBestTemplate, 0, tiers[4].price),
          tone: 'success',
        };
      }

      const unlockedTier = tiers.find((tier) => quantity === tier.quantity);
      if (unlockedTier) {
        return {
          message: formatTierMessage(container.dataset.tierUnlockedTemplate, 0, unlockedTier.price),
          tone: 'success',
        };
      }

      const nextTier = tiers.find((tier) => quantity < tier.quantity);
      return {
        message: formatTierMessage(container.dataset.tierNudgeTemplate, nextTier.quantity - quantity, nextTier.price),
        tone: 'progress',
      };
    }

    function positionTierNudge(increaseButton, nudge) {
      const buttonRect = increaseButton.getBoundingClientRect();
      const viewportMargin = 12;
      const verticalGap = 11;
      const buttonCenter = buttonRect.left + (buttonRect.width / 2);
      const nudgeWidth = nudge.offsetWidth;
      const nudgeHeight = nudge.offsetHeight;
      const maximumLeft = Math.max(viewportMargin, window.innerWidth - nudgeWidth - viewportMargin);
      const left = Math.min(Math.max(buttonCenter - (nudgeWidth / 2), viewportMargin), maximumLeft);
      const top = Math.max(viewportMargin, buttonRect.top - nudgeHeight - verticalGap);
      const arrowPosition = Math.min(Math.max(buttonCenter - left, 14), nudgeWidth - 14);

      nudge.style.setProperty('--sg-tier-left', `${left}px`);
      nudge.style.setProperty('--sg-tier-top', `${top}px`);
      nudge.style.setProperty('--sg-tier-arrow-x', `${arrowPosition}px`);
    }

    function showTierNudge(container, quantityInput, increaseButton, nudge, getMessage) {
      const tier = getMessage(container, getQuantity(quantityInput));
      const existingTimer = tierNudgeTimers.get(nudge);

      if (existingTimer) window.clearTimeout(existingTimer);
      nudge.textContent = tier.message;
      nudge.dataset.tone = tier.tone;
      positionTierNudge(increaseButton, nudge);
      nudge.setAttribute('aria-hidden', 'false');
      nudge.classList.add('is-visible');

      const hideTimer = window.setTimeout(() => {
        nudge.classList.remove('is-visible');
        nudge.setAttribute('aria-hidden', 'true');
        tierNudgeTimers.delete(nudge);
      }, 5000);
      tierNudgeTimers.set(nudge, hideTimer);
    }

    function initializeTierNudge(container, quantityInput, getMessage = getTierMessage) {
      const quantityControl = quantityInput && quantityInput.closest('quantity-input');
      const increaseButton = quantityControl && quantityControl.querySelector('button[name="plus"]');
      const form = quantityInput && quantityInput.form;
      if (!quantityControl || !increaseButton || !form) return;

      const nudge = document.createElement('span');
      nudge.className = 'sg-team-tag-tier-nudge';
      nudge.setAttribute('role', 'status');
      nudge.setAttribute('aria-live', 'polite');
      nudge.setAttribute('aria-atomic', 'true');
      nudge.setAttribute('aria-hidden', 'true');
      document.body.appendChild(nudge);

      document.addEventListener('click', (event) => {
        const clickedButton = event.target instanceof Element && event.target.closest('button[name="plus"]');
        const clickedQuantityControl = clickedButton && clickedButton.closest('quantity-input');
        const clickedQuantityInput = clickedQuantityControl && clickedQuantityControl.querySelector('input[name="quantity"]');
        if (!clickedQuantityInput || clickedQuantityInput.form !== form) return;

        requestAnimationFrame(() => {
          const activeQuantityInput = getQuantityInput(form);
          const activeQuantityControl = activeQuantityInput && activeQuantityInput.closest('quantity-input');
          const activeIncreaseButton = activeQuantityControl && activeQuantityControl.querySelector('button[name="plus"]');
          if (!activeQuantityInput || !activeIncreaseButton) return;
          showTierNudge(container, activeQuantityInput, activeIncreaseButton, nudge, getMessage);
        });
      });
    }

    function initializeClassicHypeTier(container) {
      if (container.dataset.sgClassicHypeTierInitialized === 'true') return;
      const form = document.getElementById(container.dataset.formId);
      if (!form) return;
      const quantityInput = getQuantityInput(form);
      if (!quantityInput) return;

      container.dataset.sgClassicHypeTierInitialized = 'true';
      initializeTierNudge(container, quantityInput, getClassicHypeTierMessage);

      const syncDisplayedPrice = () => {
        const activeQuantityInput = getQuantityInput(form);
        if (activeQuantityInput) updateDisplayedUnitPrice(container, activeQuantityInput);
      };

      const handleQuantityEvent = (event) => {
        if (!(event.target instanceof HTMLInputElement)) return;
        if (event.target.name !== 'quantity' || event.target.form !== form) return;
        syncDisplayedPrice();
      };

      document.addEventListener('input', handleQuantityEvent);
      document.addEventListener('change', handleQuantityEvent);
      document.addEventListener('click', (event) => {
        const quantityButton = event.target instanceof Element && event.target.closest('button[name="plus"], button[name="minus"]');
        const quantityControl = quantityButton && quantityButton.closest('quantity-input');
        const clickedQuantityInput = quantityControl && quantityControl.querySelector('input[name="quantity"]');
        if (!clickedQuantityInput || clickedQuantityInput.form !== form) return;
        requestAnimationFrame(syncDisplayedPrice);
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.quantityUpdate, syncDisplayedPrice);
        subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(syncDisplayedPrice));
      }

      syncDisplayedPrice();
    }

    function getActiveLastNameInputs(container) {
      return Array.from(container.querySelectorAll('[data-sg-last-name]:not(:disabled)'));
    }

    function formatRosterProgress(container, complete, total) {
      const template = container.dataset.rosterProgressTemplate || '[complete] of [total] entered';
      return template.replace('[complete]', String(complete)).replace('[total]', String(total));
    }

    function updateRosterSummary(container, quantityInput) {
      const quantity = getQuantity(quantityInput);
      const complete = getActiveLastNameInputs(container).filter((input) => input.value.trim()).length;
      const progress = formatRosterProgress(container, complete, quantity);
      const summary = container.querySelector('[data-sg-roster-summary]');

      container.querySelectorAll('[data-sg-roster-progress]').forEach((element) => {
        element.textContent = progress;
      });
      if (summary) summary.classList.toggle('is-complete', complete === quantity);
    }

    function openRoster(container, focusInput) {
      const dialog = container.querySelector('[data-sg-roster-dialog]');
      if (!dialog) return;
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('sg-team-tag-roster-open');

      const target = focusInput
        || getActiveLastNameInputs(container).find((input) => !input.value.trim())
        || getActiveLastNameInputs(container)[0];
      if (target) {
        requestAnimationFrame(() => {
          target.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'center' });
          if (target.validationMessage) target.reportValidity();
        });
      }
    }

    function closeRoster(container) {
      const dialog = container.querySelector('[data-sg-roster-dialog]');
      if (dialog && dialog.open) dialog.close();
    }

    function saveRoster(container, quantityInput) {
      clearError(container);
      const lastNameInputs = getActiveLastNameInputs(container);
      const blankLastName = lastNameInputs.find((input) => !input.value.trim());
      if (blankLastName) return setError(container, blankLastName, container.dataset.lastNameRequired);

      lastNameInputs.forEach((input) => {
        input.value = input.value.trim();
      });
      updateRosterSummary(container, quantityInput);
      closeRoster(container);
      return true;
    }

    function updateDisplayedUnitPrice(container, quantityInput) {
      const quantity = getQuantity(quantityInput);
      const productInfo = container.closest('.product__info-container');
      const priceContainer = productInfo && productInfo.querySelector('[id^="price-"]');
      if (!priceContainer) return;

      let displayedPrice = container.dataset.priceBase;
      if (container.matches('[data-sg-classic-hype-tier]')) {
        if (quantity >= 100) {
          displayedPrice = container.getAttribute('data-price-100');
        } else if (quantity >= 50) {
          displayedPrice = container.getAttribute('data-price-50');
        } else if (quantity >= 30) {
          displayedPrice = container.getAttribute('data-price-30');
        } else if (quantity >= 20) {
          displayedPrice = container.getAttribute('data-price-20');
        } else if (quantity >= 10) {
          displayedPrice = container.getAttribute('data-price-10');
        }
      } else if (quantity >= 50) {
        displayedPrice = container.getAttribute('data-price-50');
      } else if (quantity >= 25) {
        displayedPrice = container.getAttribute('data-price-25');
      } else if (quantity >= 10) {
        displayedPrice = container.getAttribute('data-price-10');
      }

      priceContainer.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--last').forEach((price) => {
        price.textContent = displayedPrice;
      });
    }

    function updateLastNameField(container, field, index, quantity) {
      const input = field.querySelector('[data-sg-last-name]');
      const label = field.querySelector('[data-sg-last-name-label]');
      const labelText = field.querySelector('[data-sg-last-name-label-text]');
      const fieldId = `TeamLastName-${index}-${container.dataset.formId}`;
      const isActive = index <= quantity;

      field.dataset.nameIndex = String(index);
      field.hidden = !isActive;
      field.classList.remove('sg-team-tag-personalization__field--invalid');
      label.htmlFor = fieldId;
      labelText.textContent = quantity > 1 ? `${container.dataset.lastNameLabel} ${index}` : container.dataset.lastNameLabel;
      input.id = fieldId;
      input.name = quantity > 1 ? `properties[Last name ${index}]` : 'properties[Last name]';
      input.disabled = !isActive;
      input.required = false;
      input.setAttribute('aria-required', isActive ? 'true' : 'false');
      if (!isActive) input.setCustomValidity('');
    }

    function syncLastNameFields(container, quantityInput) {
      const quantity = getQuantity(quantityInput);
      const lastNames = container.querySelector('[data-sg-last-names]');
      const firstField = lastNames.querySelector('[data-sg-last-name-field]');
      const fields = Array.from(lastNames.querySelectorAll('[data-sg-last-name-field]'));

      while (fields.length < quantity) {
        const field = firstField.cloneNode(true);
        const input = field.querySelector('[data-sg-last-name]');
        input.value = '';
        input.setCustomValidity('');
        lastNames.appendChild(field);
        fields.push(field);
      }

      fields.forEach((field, fieldIndex) => {
        updateLastNameField(container, field, fieldIndex + 1, quantity);
      });

      updateDisplayedUnitPrice(container, quantityInput);
      clearError(container);
      updateRosterSummary(container, quantityInput);
    }

    function validate(container, quantityInput) {
      syncLastNameFields(container, quantityInput);
      clearError(container);
      const fileInput = container.querySelector('input[type="file"]');
      const lastNameInputs = getActiveLastNameInputs(container);
      const file = fileInput && fileInput.files ? fileInput.files[0] : null;

      if (!file) return setError(container, fileInput, container.dataset.fileRequired);

      const extension = file.name.includes('.') ? file.name.split('.').pop().toLowerCase() : '';
      if (!allowedExtensions.includes(extension)) {
        return setError(container, fileInput, container.dataset.fileType);
      }

      if (file.size > maximumFileSize) {
        return setError(container, fileInput, container.dataset.fileSize);
      }

      const blankLastName = lastNameInputs.find((input) => !input.value.trim());
      if (blankLastName) {
        return setError(container, blankLastName, container.dataset.lastNameRequired);
      }

      lastNameInputs.forEach((input) => {
        input.value = input.value.trim();
      });
      updateRosterSummary(container, quantityInput);
      return true;
    }

    function initialize(container) {
      if (container.dataset.sgInitialized === 'true') return;
      container.dataset.sgInitialized = 'true';
      const form = document.getElementById(container.dataset.formId);
      if (!form) return;
      const quantityInput = getQuantityInput(form);
      const dialog = container.querySelector('[data-sg-roster-dialog]');
      const openButton = container.querySelector('[data-sg-roster-open]');
      const closeButton = container.querySelector('[data-sg-roster-close]');
      const saveButton = container.querySelector('[data-sg-roster-save]');
      let desiredQuantity = getQuantity(quantityInput);

      syncLastNameFields(container, quantityInput);
      initializeTierNudge(container, quantityInput);

      if (openButton) openButton.addEventListener('click', () => openRoster(container));
      if (closeButton) closeButton.addEventListener('click', () => closeRoster(container));
      if (saveButton) saveButton.addEventListener('click', () => saveRoster(container, quantityInput));

      if (dialog) {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeRoster(container);
        });

        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('sg-team-tag-roster-open');
          getActiveLastNameInputs(container).forEach((input) => input.setCustomValidity(''));
          const rosterError = container.querySelector('[data-sg-roster-error]');
          if (rosterError) {
            rosterError.textContent = '';
            rosterError.hidden = true;
          }
          updateRosterSummary(container, quantityInput);
          if (openButton) openButton.focus({ preventScroll: true });
        });

        dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' || !event.target.matches('[data-sg-last-name]')) return;
          event.preventDefault();
          const activeInputs = getActiveLastNameInputs(container);
          const currentIndex = activeInputs.indexOf(event.target);
          const nextInput = activeInputs[currentIndex + 1];
          if (nextInput) {
            nextInput.focus();
          } else {
            saveRoster(container, quantityInput);
          }
        });
      }

      form.addEventListener('submit', (event) => {
        if (validate(container, quantityInput)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);

      container.addEventListener('input', (event) => {
        if (!event.target.matches('input')) return;
        clearError(container);
        if (event.target.matches('[data-sg-last-name]')) updateRosterSummary(container, quantityInput);
      });

      container.addEventListener('change', (event) => {
        if (!event.target.matches('input')) return;
        clearError(container);
        if (event.target.matches('[data-sg-last-name]')) updateRosterSummary(container, quantityInput);
      });

      if (quantityInput) {
        const handleQuantityChange = () => {
          desiredQuantity = getQuantity(quantityInput);
          syncLastNameFields(container, quantityInput);
        };

        quantityInput.addEventListener('input', handleQuantityChange);
        quantityInput.addEventListener('change', handleQuantityChange);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.quantityUpdate, () => syncLastNameFields(container, quantityInput));
          subscribe(PUB_SUB_EVENTS.variantChange, () => {
            requestAnimationFrame(() => {
              quantityInput.value = String(desiredQuantity);
              quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
              updateDisplayedUnitPrice(container, quantityInput);
            });
          });
        }
      }
    }

    function initializeAll() {
      document.querySelectorAll('[data-sg-team-tag-personalization]').forEach(initialize);
      document.querySelectorAll('[data-sg-classic-hype-tier]').forEach(initializeClassicHypeTier);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
